module.exports = __webpack_public_path__ + "img/icon_upload_default copy 2.6acabf92.svg";